export default "__VITE_ASSET__943016c2__"